import QuestionnairesGated from './QuestionnairesGated';

export default QuestionnairesGated;
